import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface NavigationCardProps {
  title: string;
  description: string;
  icon: SvgIconComponent;
  color: string;
  onClick: () => void;
}

const NavigationCard: React.FC<NavigationCardProps> = ({
  title,
  description,
  icon: Icon,
  color,
  onClick
}) => {
  return (
    <Card
      sx={{
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #e2e8f0',
        borderLeft: `4px solid ${color}`,
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 25px rgba(0,0,0,0.12)',
        },
      }}
      onClick={onClick}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              backgroundColor: `${color}15`,
              borderRadius: '50%',
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon sx={{ color, fontSize: '1.75rem' }} />
          </Box>
          <Box flex={1}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, color: '#1e293b' }}
            >
              {title}
            </Typography>
            <Typography
              variant="body2"
              color="#64748b"
              sx={{ fontSize: '0.875rem' }}
            >
              {description}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default NavigationCard;
